import { render, staticRenderFns } from "./ConfiguracionComandosSMSPantalla.vue?vue&type=template&id=47e019b6&scoped=true&"
import script from "./ConfiguracionComandosSMSPantalla.vue?vue&type=script&lang=ts&"
export * from "./ConfiguracionComandosSMSPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e019b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('47e019b6', component.options)
    } else {
      api.reload('47e019b6', component.options)
    }
    module.hot.accept("./ConfiguracionComandosSMSPantalla.vue?vue&type=template&id=47e019b6&scoped=true&", function () {
      api.rerender('47e019b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/ConfiguracionComandosSMS/ConfiguracionComandosSMSPantalla.vue"
export default component.exports